import { render, staticRenderFns } from "./NewAnket.vue?vue&type=template&id=90d78360"
import script from "./NewAnket.vue?vue&type=script&lang=js"
export * from "./NewAnket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports